import dayjs from 'dayjs';
import { Utils, CaseType, CaseTypeText } from '@gv/triage-components';

import { TaskPriority, CasesFilterValues } from 'types';

export const initialValues: CasesFilterValues = {
  type: '',
  level: '',
  issues: [],
  is_test: '',
  holdTime: '',
  location: [],
  caseType: '',
  feedback: '',
  totalTime: '',
  hospitalId: '',
  caseStatus: '',
  endDate: undefined,
  startDate: undefined,
  wasAutoSubmitted: '',
};

export const initialFilters = (isTeamPortal: boolean) => {
  const endDate = dayjs();
  return {
    ...initialValues,
    is_test: 'no',
    endDate: endDate.toISOString(),
    startDate: isTeamPortal
      ? endDate.subtract(89, 'day').startOf('day').toISOString()
      : endDate.subtract(1, 'months').startOf('day').toISOString(),
  };
};

export const typeOptions = [
  {
    value: String(CaseType.Call),
    label: CaseTypeText[CaseType.Call] || 'Call',
  },
  {
    value: String(CaseType.SMS),
    label: CaseTypeText[CaseType.SMS] || 'SMS',
  },
  {
    value: String(CaseType.VirtualExam),
    label: CaseTypeText[CaseType.VirtualExam] || 'Virtual Exam',
  },
];

export const timeIntervalOptions = [
  { label: '< 5min', value: 'lt_300' },
  { value: 'lt_600', label: '< 10min' },
  { value: 'lt_900', label: '< 15min' },
  { label: '< 20min', value: 'lt_1200' },
  { label: '< 25min', value: 'lt_1500' },
  { label: '< 30min', value: 'lt_1800' },
  { label: '> 30min', value: 'gt_1800' },
];

export const levelOptions = Object.values(TaskPriority).map((value) => ({
  value: Utils.String.capitalize(value),
  label: Utils.String.capitalize(value),
}));

export const caseStatusOptions = [
  { value: 'completed', label: 'Completed' },
  { label: 'Incomplete', value: 'notCompleted' },
];

export const feedbackOptions = [
  { value: 'provided', label: 'Provided' },
  { value: 'notProvided', label: 'Not provided' },
];

export const isTestOptions = [
  { value: 'yes', label: 'Test Cases Only' },
  { value: 'no', label: 'Without Test Cases' },
  { value: 'all', label: 'All Cases' },
];

export const isTestCallTitle = 'Calls';
